import { Box } from '@mui/material'
import React from 'react'
import HealthCheck from 'src/components/global/HealthCheck'

function NoGuard({ children }) {
    return (
        <Box display={'flex'} flexDirection={'column'}>
            <HealthCheck />
            {children}
        </Box>
    )
}

export default NoGuard